<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead">Contents</h1>
<h2 class="toc"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toct"><a href="#/xhtml/08_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc1t"><a href="#/xhtml/09_Chapter_1"><span class="tochang">Chapter 1</span> The Price of Glory</a></h2>
<h2 class="toc1"><a href="#/xhtml/10_Chapter_2"><span class="tochang">Chapter 2</span> Holy War</a></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter_3" title="Link target outside of Sample"><span class="tochang">Chapter 3</span> Inaction at the Alma</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_Chapter_4" title="Link target outside of Sample"><span class="tochang">Chapter 4</span> The Flank March</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_Chapter_5" title="Link target outside of Sample"><span class="tochang">Chapter 5</span> The Siege of Sevastopol</span></h2>
<h2 class="toc1"><span href="#/xhtml/14_Chapter_6" title="Link target outside of Sample"><span class="tochang">Chapter 6</span> ‘The Brilliant Attack’</span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Chapter_7" title="Link target outside of Sample"><span class="tochang">Chapter 7</span> ‘That Thin Red Streak’</span></h2>
<h2 class="toc1"><span href="#/xhtml/16_Chapter_8" title="Link target outside of Sample"><span class="tochang">Chapter 8</span> ‘Forward the Light Brigade’</span></h2>
<h2 class="toc1"><span href="#/xhtml/17_Chapter_9" title="Link target outside of Sample"><span class="tochang">Chapter 9</span> ‘Magnificent But Not War’</span></h2>
<h2 class="toc1"><span href="#/xhtml/18_Chapter_10" title="Link target outside of Sample"><span class="tochang">Chapter 10</span> ‘To Do or Die’</span></h2>
<h2 class="toc1"><span href="#/xhtml/19_Chapter_11" title="Link target outside of Sample"><span class="tochang">Chapter 11</span> ‘Someone Had Blundered’</span></h2>
<h2 class="toc1"><span href="#/xhtml/20_Chapter_12" title="Link target outside of Sample"><span class="tochang">Chapter 12</span> ‘Honour the Light Brigade’</span></h2>
<h2 class="toc1"><span href="#/xhtml/21_Chapter_13" title="Link target outside of Sample"><span class="tochang">Chapter 13</span> Tarnished Glory</span></h2>
<h2 class="toct"><span href="#/xhtml/22_Notes" title="Link target outside of Sample">References and Notes</span></h2>
<h2 class="toct"><span href="#/xhtml/23_Bibliography" title="Link target outside of Sample">Bibliography and Sources</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?731c4eb6